import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromGenericBulkUpsert from './generic-bulk-upsert.reducer';

export interface GenericBulkUpsertFeatureState {
  genericBulkUpsert: fromGenericBulkUpsert.GenericBulkUpsertState;
}

export const reducers: ActionReducerMap<GenericBulkUpsertFeatureState> = {
  genericBulkUpsert: fromGenericBulkUpsert.reducer
};

export const getGenericBulkUpsertFeatureState = createFeatureSelector<GenericBulkUpsertFeatureState>('genericBulkUpsert');

export { GenericBulkUpsertState } from './generic-bulk-upsert.reducer';